export default {
  FAILED_CONNECTION_NOTIFICATION: '',
  // Do not localize {Retry}; it is a placeholder for "Retry". English translation should be, "Send failed. Retry."
  SEND_FAILED_KEY: `nem sikerült elküldeni, {Retry}.`,
  SLOW_CONNECTION_NOTIFICATION: '',
  Chat: 'Csevegés',
  // 'Download file': '',
  // 'Microphone off': '',
  // 'Microphone on': '',
  'Listening…': 'Figyelés…',
  Retry: 'próbálja újra',
  Send: 'Küldés',
  Sending: 'küldés',
  // 'Speak': '',
  // 'Starting…': '',
  Tax: 'Adó',
  Total: 'Összesen',
  'Type your message': 'Írja be üzenetét',
  // 'Upload file': '',
  VAT: 'ÁFA'
  // 'X minutes ago':
};
